// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"_15E7z","couponContainer":"_2JjQg","headerTitle":"_3Sv9i","headerSubtitle":"_3Ran6","couponText":"_2KyE9"};